import _classCallCheck from "/home/travis/build/Adrian265431/viadeUO265431/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/travis/build/Adrian265431/viadeUO265431/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/travis/build/Adrian265431/viadeUO265431/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/travis/build/Adrian265431/viadeUO265431/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/travis/build/Adrian265431/viadeUO265431/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/home/travis/build/Adrian265431/viadeUO265431/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
// **N3StreamWriter** serializes a quad stream into a text stream.
import { Transform } from 'stream';
import N3Writer from './N3Writer'; // ## Constructor

var N3StreamWriter =
/*#__PURE__*/
function (_Transform) {
  _inherits(N3StreamWriter, _Transform);

  function N3StreamWriter(options) {
    var _this;

    _classCallCheck(this, N3StreamWriter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(N3StreamWriter).call(this, {
      encoding: 'utf8'
    }));
    _this._writableState.objectMode = true; // Set up writer with a dummy stream object

    var self = _assertThisInitialized(_assertThisInitialized(_this));

    var writer = _this._writer = new N3Writer({
      write: function write(quad, encoding, callback) {
        self.push(quad);
        callback && callback();
      },
      end: function end(callback) {
        self.push(null);
        callback && callback();
      }
    }, options); // Implement Transform methods on top of writer

    _this._transform = function (quad, encoding, done) {
      writer.addQuad(quad, done);
    };

    _this._flush = function (done) {
      writer.end(done);
    };

    return _this;
  } // ### Serializes a stream of quads


  _createClass(N3StreamWriter, [{
    key: "import",
    value: function _import(stream) {
      var self = this;
      stream.on('data', function (quad) {
        self.write(quad);
      });
      stream.on('end', function () {
        self.end();
      });
      stream.on('error', function (error) {
        self.emit('error', error);
      });
      stream.on('prefix', function (prefix, iri) {
        self._writer.addPrefix(prefix, iri);
      });
      return this;
    }
  }]);

  return N3StreamWriter;
}(Transform);

export { N3StreamWriter as default };